<template>
  <div
    class="dropdown"
    @mouseenter="handleOpen"
    @mouseleave="handleMaybeClose"
    v-click-outside="handleClose"
  >
    <BaseDropdownToggle>{{ $props.label }}</BaseDropdownToggle>

    <div v-if="isOpen" class="dropdown-menu" :class="{ show: isOpen }">
      <slot name="first" />

      <slot
        name="default"
        v-bind="{ options, open: handleOpen, close: handleClose }"
      >
        <BaseDropdownContent>
          <template v-slot:item="slotProps">
            <slot name="item" v-bind="slotProps" />
          </template>
        </BaseDropdownContent>
      </slot>
    </div>
  </div>
</template>

<script>
import { defineComponent, provide, ref, watch } from '@vue/composition-api'

import { BaseDropdownInjectionKey } from './BaseDropdown.constants'

import BaseDropdownToggle from './BaseDropdownToggle.vue'
import BaseDropdownContent from './BaseDropdownContent.vue'

export default defineComponent({
  name: 'BaseDropdown',
  components: {
    BaseDropdownToggle,
    BaseDropdownContent
  },
  props: {
    options: {
      type: Array,
      validator: (options) => {
        const isValid = options.every((option) => {
          const keys = Object.keys(option)

          return keys.includes('value') && keys.includes('text')
        })

        return isValid
      },
      default: () => [],
      required: true
    },
    label: String,
    toggleClass: [String, Array]
  },
  emits: ['click:option'],
  setup(props, { emit }) {
    const isOpen = ref(false)
    const isMaybeClosing = ref(false)

    const closingTimer = ref(null)

    const handleOpen = () => {
      isOpen.value = true

      emit('change', true)

      if (isMaybeClosing.value) isMaybeClosing.value = false
    }

    const handleClose = () => {
      isOpen.value = false

      emit('change', false)
    }

    const handleMaybeClose = () => {
      isMaybeClosing.value = true
    }

    watch(isMaybeClosing, (newIsMaybeClosing) => {
      if (newIsMaybeClosing)
        closingTimer.value = setTimeout(() => (isOpen.value = false), 500)
      else clearTimeout(closingTimer.value)
    })

    provide(BaseDropdownInjectionKey, {
      options: props.options,
      label: props.label,
      toggleClass: props.toggleClass,

      isOpen
    })

    return {
      BaseDropdownInjectionKey,

      isOpen,

      handleOpen,
      handleClose,
      handleMaybeClose
    }
  }
})
</script>
